import { gql } from '@apollo/client'

export const GET_DEFAULT_WATCHLIST = gql`
  query getDefaultWatchList {
    getMyDefaultWatchList {
      id
      items(first: 100) {
        edges {
          node {
            id
            content {
              __typename
              ... on ContentDisplayable {
                id
                imageLandscape: image(category: ANGEL_KEY_ART_1, aspect: "16:9") {
                  cloudinaryPath
                }
                imagePortrait: image(category: ANGEL_KEY_ART_1, aspect: "2:3") {
                  cloudinaryPath
                }
                name
                description(version: SHORT)
              }
              ... on ContentSeries {
                project {
                  id
                  slug
                }
              }
              ... on ContentSpecial {
                project {
                  id
                  slug
                }
              }
              ... on ContentMovie {
                project {
                  id
                  slug
                }
              }
            }
          }
        }
      }
    }
  }
`

export const CONTENT_IN_WATCHLIST = gql`
  query getContentInWatchList($contentId: String!) {
    contentInWatchList(contentId: $contentId) {
      id
      content {
        __typename
        ... on ContentDisplayable {
          id
        }
      }
    }
  }
`

export const ADD_TO_WATCHLIST = gql`
  mutation addToWatchList($contentId: String!) {
    addToWatchList(contentId: $contentId) {
      id
    }
  }
`

export const DELETE_FROM_WATCHLIST = gql`
  mutation deleteFromWatchList($contentId: String!) {
    deleteFromWatchList(contentId: $contentId) {
      id
    }
  }
`
